import { render, staticRenderFns } from "./TransactionPackages.vue?vue&type=template&id=38b424e5"
import script from "./TransactionPackages.vue?vue&type=script&lang=js"
export * from "./TransactionPackages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports